module.exports = __webpack_public_path__ + "img/logo_main.3e0098dd.png";